var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "background" },
    [
      _c(
        "div",
        { staticClass: "app-container" },
        [
          _c("div", { staticClass: "header" }, [
            _c(
              "div",
              { staticClass: "header-title" },
              [
                _c("el-button", { on: { click: _vm.backToAttendanceIndex } }, [
                  _vm._v("戻る"),
                ]),
                _vm._v(" 勤怠情報の追加"),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("AttendanceForm", {
            attrs: {
              form: _vm.form,
              "show-form": _vm.showForm,
              "submit-btn-name": _vm.submitBtnName,
              loading: _vm.loading,
            },
            on: {
              postFormSubmit: _vm.postFormSubmit,
              backToContractIndex: _vm.backToAttendanceIndex,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "確認",
            visible: _vm.waitDialogVisible,
            width: "30%",
            "close-on-click-modal": false,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.waitDialogVisible = $event
            },
          },
        },
        [_c("span", [_vm._v(_vm._s(_vm.submitBtnName) + "中！")])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }